export enum CardVariant {
  DEFAULT = "default",
  WARNING = "warning",
}
